import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export const CoverageFaq = () => (
<AccordionItem value="item-3" className="bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-900/40 rounded-xl px-6">
                <AccordionTrigger data-testid="faq-question-3" className="text-white hover:text-red-500 text-lg font-semibold">
                  Le sorcier vaudou Maître Diamma intervient-il dans toute la Guadeloupe ?
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 leading-relaxed">
                  Absolument ! Le grand <strong className="text-white">marabout sorcier vaudou Maître Diamma</strong> intervient dans toutes les villes 
                  et communes de Guadeloupe : Pointe-à-Pitre, Les Abymes, Baie-Mahault, Le Gosier, Sainte-Anne, Saint-François, Le Moule, Petit-Bourg, 
                  Basse-Terre, et toutes les autres localités. Pour les consultations urgentes, Maître Diamma se déplace personnellement. Des consultations 
                  à distance sont également disponibles via WhatsApp, par téléphone ou par vidéo pour ceux qui ne peuvent pas se déplacer. Les rituels 
                  de <strong className="text-red-400">sorcier vaudou</strong> sont tout aussi efficaces à distance qu'en personne.
                </AccordionContent>
              </AccordionItem>
);
